import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { RFQ_DETAILS_CACHE_KEY, useIsFeatureSupported, useUserSelfDetails, userHasRole } from '@steelbuy/data-access';
import { Feature, UserRole } from '@steelbuy/ts-shared';
import { SuccessErrorNotificationContextProvider } from '@steelbuy/ui-primitive';
import { RFQDetails } from '../../components/my-rfqs/RFQDetails';
import { RoutePath } from '../../router/Routes';

export const MyRequestQuotesDetailsView = () => {
    const { rfqId = null } = useParams();
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const { data: userModel } = useUserSelfDetails();
    const hasBuyerRole = userHasRole(userModel || null, [UserRole.BUYER]);
    const showRfq = useIsFeatureSupported(Feature.NA_RFQ) && hasBuyerRole;

    useEffect(
        () => () => {
            queryClient.removeQueries({ queryKey: [RFQ_DETAILS_CACHE_KEY] });
        },
        []
    );

    if (!showRfq) {
        navigate(RoutePath.DASHBOARD);
        return null;
    }

    return (
        <SuccessErrorNotificationContextProvider stayOpen>
            <RFQDetails rfqId={rfqId ?? ''} goBackPath={RoutePath.MY_REQUEST_QUOTE} />
        </SuccessErrorNotificationContextProvider>
    );
};
